import { defineMessages } from 'react-intl';

export default defineMessages({
  postcodeLabel: {
    id: 'geoMultiQuotes.postcodeLabel',
    defaultMessage: 'Enter your zip code to get a quote',
  },
  buttonText: {
    id: 'geoMultiQuotes.buttonText',
    defaultMessage: 'Get Instant Quote',
  },
  postcodeError: {
    id: 'geoMultiQuotes.postcodeError',
    defaultMessage: 'Please enter valid zip code',
  },
  postcodePlaceholder: {
    id: 'geoMultiQuotes.postcodePlaceholder',
    defaultMessage: 'Enter zip code',
  },
  locationError: {
    id: 'geoMultiQuotes.locationError',
    defaultMessage: 'Location not supported',
  },
});
